import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  display: block;

  & .st0 {
    fill: #0072ba;
  }

  & .st1 {
    fill: #041556;
  }

  & .st2 {
    fill: #fdbb11;
  }

  & .st3 {
    fill: none;
  }

  & .st4 {
    fill: #fefefe;
  }
`;

const RoyalLogo = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 158 42"
    >
      <g>
        <polygon
          id="Fill-1_1_"
          className="st0"
          points="1,40.1 156.5,40.1 156.5,1.7 1,1.7 	"
        />
        <polygon
          id="Fill-2_1_"
          className="st1"
          points="1,40.1 38.9,40.1 38.9,1.7 1,1.7 	"
        />
        <polygon
          id="Fill-3_1_"
          className="st2"
          points="38.9,40.1 156.5,40.1 156.5,28.3 38.9,28.3 	"
        />
        <path
          id="Fill-8_1_"
          className="st1"
          d="M78,33.4h0.6c0.7,0,1.1-0.3,1.1-0.8s-0.4-0.8-1-0.8H78V33.4L78,33.4z M77.3,31.1h1.3
            c1,0,2,0.2,2,1.4c0,0.6-0.5,1.1-1.1,1.2l0,0c0.2,0.1,0.3,0.2,0.5,0.5l1,2.1h-0.8l-0.8-1.8C79.2,34,78.9,34,78.5,34H78v2.3h-0.7
            V31.1L77.3,31.1z"
        />
        <polygon
          id="Fill-10_1_"
          className="st1"
          points="85.9,31.1 86.9,31.1 89.2,35.4 89.2,35.4 89.2,31.1 90,31.1 90,36.4 89,36.4 
            86.7,32.1 86.6,32.1 86.6,36.4 85.9,36.4 	"
        />
        <path
          id="Fill-12_1_"
          className="st1"
          d="M97.3,31.9l-1,2.6h2.1L97.3,31.9z M97,31.1h0.8l2.2,5.3h-0.8l-0.5-1.3h-2.5l-0.5,1.3h-0.8
            L97,31.1z"
        />
        <polygon
          id="Fill-14_1_"
          className="st1"
          points="105.2,31.8 103.6,31.8 103.6,31.1 107.6,31.1 107.6,31.8 106,31.8 106,36.4 
            105.2,36.4 	"
        />
        <polygon
          id="Clip-17_1_"
          className="st3"
          points="1,39.5 156.5,39.5 156.5,1.2 1,1.2 	"
        />
        <polygon
          id="Fill-16_1_"
          className="st1"
          points="112.3,36.4 113.1,36.4 113.1,31.1 112.3,31.1 	"
        />
        <path
          id="Fill-18_1_"
          className="st1"
          d="M120.7,35.8c1.2,0,1.7-1,1.7-2.1s-0.6-2.1-1.7-2.1s-1.7,1-1.7,2.1
            C119,34.8,119.5,35.8,120.7,35.8 M120.7,31.1c1.6,0,2.5,1.2,2.5,2.7c0,1.6-0.9,2.7-2.5,2.7s-2.5-1.1-2.5-2.7
            C118.2,32.2,119.1,31.1,120.7,31.1"
        />
        <polygon
          id="Fill-19_1_"
          className="st1"
          points="128.3,31.1 129.3,31.1 131.6,35.4 131.6,35.4 131.6,31.1 132.3,31.1 132.3,36.4 
            131.4,36.4 129,32.1 129,32.1 129,36.4 128.3,36.4 	"
        />
        <path
          id="Fill-20_1_"
          className="st1"
          d="M139.7,31.9l-1,2.6h2.1L139.7,31.9z M139.3,31.1h0.8l2.2,5.3h-0.8l-0.5-1.3h-2.5l-0.5,1.3
            h-0.8L139.3,31.1z"
        />
        <polygon
          id="Fill-21_1_"
          className="st1"
          points="147.1,31.1 147.8,31.1 147.8,35.7 150,35.7 150,36.4 147.1,36.4 	"
        />
        <path
          id="Fill-22_1_"
          className="st4"
          d="M20,6.6c1.4,1.3,2.9,2.7,4.2,4.1l-1.5,2v0.1l4.1,1.8l2.8-1.9l-1.7-1.9v-0.1
            c1.7-1.2,3.2-2.4,4.8-3.5l-0.8,8.4H8.1L7.3,7.2c1.7,1.1,3.1,2.3,4.8,3.5v0.1l-1.7,1.9l2.8,1.9l4.1-1.8v-0.1l-1.5-2
            C17,9.3,18.6,7.9,20,6.6L20,6.6z"
        />
        <path
          id="Fill-23_1_"
          className="st4"
          d="M31.7,17.1l-0.2,2.8h-8.8v9.6H27c1,0,2-1,1.8-1.7c-0.2-1-1.1-1.6-1.9-2.1
            c0.2,0,3.1-2.2,4.5-3.1c-0.1,0.6-1,8.5-1.1,8.6L20,35.1h-0.2L9.7,31.2c0-0.1-1-8-1.1-8.6c1.4,0.9,4.3,3.1,4.5,3.1
            c-0.8,0.5-1.7,1.1-1.9,2.1C11,28.5,12,29.5,13,29.5h4.3v-9.6H8.5l-0.2-2.8H31.7z"
        />
        <path
          id="Fill-24_1_"
          className="st4"
          d="M47,14.4c1.7,0,3.7-0.8,3.7-2.8c0-2.1-1.8-2.9-3.7-2.9V14.4z M45.4,12.1
            c0-2.7-0.1-3.2-2.1-3.3V8.5l4.3-0.1c4.5-0.1,4.8,2.1,4.8,2.9c0,1.5-0.9,2.4-2.2,2.9l0.1,0.1c1.4,2.4,3.1,5.5,6,6.1l-0.1,0.3
            c-1.9-0.1-3.3,0-4.3-1.1c-1.2-1.2-2.1-2.8-2.5-3.6c-0.7-1.5-1.3-1.1-2.6-1.3v2.9c0,2,0,2.3,2.5,2.7v0.3h-6.2v-0.3
            c2.1-0.3,2.1-0.8,2.2-2.7L45.4,12.1L45.4,12.1z"
        />
        <path
          id="Fill-25_1_"
          className="st4"
          d="M58.9,12.9c-1.9,0-2.7,2-2.7,3.7s0.9,3.8,2.8,3.8c1.8,0,2.6-2.1,2.6-3.6
            C61.7,15.1,60.9,12.9,58.9,12.9 M58.9,20.7c-2.4,0-4.4-1.6-4.4-4.1s2-4.2,4.4-4.2s4.3,1.6,4.3,4.1C63.3,19,61.3,20.7,58.9,20.7"
        />
        <path
          id="Fill-26_1_"
          className="st4"
          d="M63.9,14.3c-0.3-0.8-0.4-1-1.3-1.1v-0.3h3.7v0.3c-1.3,0.1-1,0.9-0.6,1.8l1.7,4.6l1.1-3.2
            c0.8-2.3,0.9-3-0.4-3.1V13h3.1v0.3c-0.8,0.1-1,0.4-1.4,1.1L69.1,16l-2.7,6.9c-0.7,1.7-1.1,2.2-1.8,2.2c-0.5,0-0.9-0.4-0.9-0.9
            c0-0.4,0.2-0.7,0.6-0.8c0.2,0.1,0.7,0.5,0.9,0.5c0.4,0,0.7-1,0.8-1.2l0.6-1.4L63.9,14.3z"
        />
        <path
          id="Fill-27_1_"
          className="st4"
          d="M72.3,17.7c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.8,0.4,1.4,1.2,1.4c0.5,0,1-0.3,1.3-0.7v-2.7
            L72.3,17.7z M74.7,16.1c0.1-2-0.4-2.8-1.8-2.8c-1.2,0-1.1,0.6-1.1,1.6L71,15c-0.1,0-0.4,0-0.4-0.2c0-0.5,2-2.3,3.4-2.3
            c1.6,0,2.1,1.3,2.1,2.7v2.5c0,1.6-0.1,2.6,1.5,2.3v0.4c-0.7,0.2-1.3,0.3-1.8,0.3c-0.7,0-1-0.4-1.1-1.1c-0.6,0.6-1.3,1.2-2.3,1.2
            c-1.1,0-1.8-1-1.8-2c0-0.3,0-0.5,0.1-0.8L74.7,16.1z"
        />
        <path
          id="Fill-28_1_"
          className="st4"
          d="M76.8,20.6v-0.4c1.2-0.1,1.4-0.4,1.4-1.6V11c0-0.8,0-1-0.9-1.6V9.1l2-0.8l0.2,0.1v10.1
            c0,1.5,0.1,1.6,1.4,1.8v0.3C80.9,20.6,76.8,20.6,76.8,20.6z"
        />
        <path
          id="Fill-29_1_"
          className="st4"
          d="M95.3,17.7c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.8,0.4,1.4,1.2,1.4c0.5,0,1-0.3,1.3-0.7v-2.7
            L95.3,17.7z M97.7,16.1c0.1-2-0.4-2.8-1.8-2.8c-1.2,0-1.1,0.6-1.1,1.6L94,15c-0.1,0-0.4,0-0.4-0.2c0-0.5,1.9-2.3,3.4-2.3
            c1.6,0,2.1,1.3,2.1,2.7v2.5c0,1.6-0.2,2.7,1.5,2.3v0.4c-0.7,0.2-1.3,0.3-1.8,0.3c-0.7,0-1-0.4-1.1-1.1c-0.6,0.6-1.3,1.2-2.3,1.2
            c-1.1,0-1.8-1-1.8-2c0-0.3,0-0.5,0.1-0.8L97.7,16.1z"
        />
        <path
          id="Fill-30_1_"
          className="st4"
          d="M92.5,12.1h-0.3c-0.3-2-1.5-3.5-3.6-3.5c-3.2,0-5.1,2.7-5.1,5.8c0,3.5,2.7,6,5.2,6
            c2.3,0,3.2-1.7,4-3.7l0.2,0.1c-0.2,1.1-0.5,2.2-1,3.2c-1.1,0.6-2.4,0.8-3.6,0.8c-3.7,0-7-2.2-7-6.2c0-3.2,2.5-6.4,7.1-6.4
            c1.3,0,2.7,0.3,3.9,1v2.9H92.5z"
        />
        <path
          id="Fill-31_1_"
          className="st4"
          d="M137.5,17.7c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.8,0.4,1.4,1.2,1.4c0.5,0,1-0.3,1.3-0.7v-2.7
            L137.5,17.7z M139.9,16.1c0.1-2-0.4-2.8-1.8-2.8c-1.2,0-1.1,0.6-1.1,1.6l-0.9,0.1c-0.1,0-0.4,0-0.4-0.2c0-0.5,2-2.3,3.4-2.3
            c1.6,0,2.1,1.3,2.1,2.7v2.5c0,1.6-0.3,2.6,1.4,2.5v0.3c-0.7,0.2-1.1,0.2-1.6,0.2c-0.7,0-1-0.4-1.1-1.1c-0.6,0.6-1.3,1.2-2.3,1.2
            c-1.1,0-1.8-1-1.8-2c0-0.3,0-0.5,0.1-0.8L139.9,16.1z"
        />
        <path
          id="Fill-32_1_"
          className="st4"
          d="M102.6,18.5c0,1.5,0.1,1.6,1.8,1.8v0.3H100v-0.4c1.2-0.1,1.3-0.4,1.3-1.8v-3.3
            c0-0.8,0-1-0.9-1.6v-0.2l2.1-0.8l0.2,0.1l-0.1,2.1l0,0c0.4-0.9,1.4-2.2,2.5-2.2c0.5,0,0.9,0.3,0.9,0.8s-0.5,0.9-0.9,1.1
            c-0.3-0.2-0.7-0.6-1.1-0.6c-1.5,0.1-1.4,2.6-1.4,2.8V18.5z"
        />
        <path
          id="Fill-33_1_"
          className="st4"
          d="M109.4,9.5c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S109.4,9,109.4,9.5
            L109.4,9.5z M106.5,20.6v-0.3c1.3-0.2,1.4-0.4,1.4-1.8v-3.4c0-0.8,0-1-1.1-1.6v-0.2l2.3-0.8l0.2,0.1v5.9c0,1.5,0.1,1.6,1.4,1.8v0.3
            H106.5z"
        />
        <path
          id="Fill-34_1_"
          className="st4"
          d="M112.7,16.9c0,1.7,0.2,3.3,2.2,3.3c1,0,2.6-0.8,2.6-3.3c0-2.2-1.4-3.5-3.1-3.5
            c-0.6,0-1.1,0.2-1.6,0.4L112.7,16.9L112.7,16.9z M111.3,10.9c0-0.8,0-1-0.9-1.6V9.1l2-0.8l0.2,0.1v5.1c0.9-0.5,2-1,3-1
            c2,0,3.3,1.8,3.3,3.7c0,3.2-2.9,4.6-4.8,4.6c-1.1,0-1.9-0.3-2.8-0.7C111.3,20.1,111.3,10.9,111.3,10.9z"
        />
        <path
          id="Fill-35_1_"
          className="st4"
          d="M121.2,16.9c0,1.7,0.2,3.3,2.2,3.3c1,0,2.6-0.8,2.6-3.3c0-2.2-1.4-3.5-3.1-3.5
            c-0.6,0-1.1,0.2-1.6,0.4L121.2,16.9L121.2,16.9z M119.8,10.9c0-0.8,0-1-0.9-1.6V9.1l2-0.8l0.2,0.1v5.1c0.9-0.5,2-1,3-1
            c2,0,3.3,1.8,3.3,3.7c0,3.2-2.9,4.6-4.8,4.6c-1.1,0-1.9-0.3-2.8-0.7C119.8,20.1,119.8,10.9,119.8,10.9z"
        />
        <path
          id="Fill-36_1_"
          className="st4"
          d="M133.3,14.6c-0.2-0.8-0.7-1.8-1.6-1.8c-1,0-1.6,1-1.8,1.9L133.3,14.6z M129.8,16
            c-0.1,1.9,1.1,3.6,3.1,3.6c0.9,0,1.6-0.4,2.1-1.1l0.3,0.2c-0.7,1.2-1.9,2.1-3.3,2.1c-2.2,0-3.7-1.8-3.7-4c0-2.3,1.6-4.3,4-4.3
            c1.6,0,2.7,1,2.7,2.6h-5.1L129.8,16z"
        />
        <path
          id="Fill-37_1_"
          className="st4"
          d="M143.4,15.1c0-0.8,0-1-0.9-1.6v-0.2l2.1-0.8l0.2,0.1l-0.1,1.3c1-0.8,2-1.4,3.1-1.4
            c2.1,0,2.2,1.8,2.2,2.8v3.2c0,1.5,0.1,1.6,1.4,1.8v0.3h-4.1v-0.3c1.3-0.2,1.4-0.4,1.4-1.8v-2.1c0-1.3,0.1-3-2.1-3
            c-0.7,0-1.2,0.2-1.8,0.8v4.3c0,1.5,0.1,1.6,1.4,1.8v0.3H142v-0.3c1.3-0.1,1.4-0.4,1.4-1.8V15.1z"
        />
        <polygon
          id="Fill-4_1_"
          className="st1"
          points="45.5,36.4 46.2,36.4 46.2,31.1 45.5,31.1 	"
        />
        <polygon
          id="Fill-5_1_"
          className="st1"
          points="51.6,31.1 52.6,31.1 54.9,35.4 54.9,35.4 54.9,31.1 55.7,31.1 55.7,36.4 54.7,36.4 
            52.3,32.1 52.3,32.1 52.3,36.4 51.6,36.4 	"
        />
        <polygon
          id="Fill-6_1_"
          className="st1"
          points="62,31.8 60.4,31.8 60.4,31.1 64.4,31.1 64.4,31.8 62.8,31.8 62.8,36.4 62,36.4 	"
        />
        <polygon
          id="Fill-7_1_"
          className="st1"
          points="69.2,31.1 72.1,31.1 72.1,31.8 69.9,31.8 69.9,33.3 71.9,33.3 71.9,34 69.9,34 
            69.9,35.7 72.1,35.7 72.1,36.4 69.2,36.4 	"
        />
      </g>
    </Svg>
  );
};

export default RoyalLogo;
